// Warm-earth rotation (Feb-2026 v10) — matches the same palette used
// by SpeakerCard's tile backdrop for transparent cutouts, so
// initials/color-only tiles stay visually consistent with the rest of
// the grid. Excludes browns/bronzes and warm-charcoals per user's
// "all but browns" choice from the /palette-preview study.
export const getColorFromString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colors = [
    // Rust family (9)
    '#9a7b24', '#7d6119', '#b0862a', '#a8801b', '#b58a2f',
    '#8c6a20', '#8b4a1e', '#9c5836', '#a4842d',
    // Warm navy family (9)
    '#1f2b47', '#0f1729', '#232f4e', '#1a1f45', '#1c2542',
    '#2a3652', '#2c3a5c', '#183050', '#152547',
    // Warm reds (6)
    '#5c1f27', '#4b1a1d', '#6c2732', '#5b2a1d', '#6b1f2a', '#5a2b1d',
    // Warm greens (5)
    '#2c3d24', '#3f3d1e', '#3a3c1a', '#374631', '#2f3c26',
  ];

  return colors[Math.abs(hash) % colors.length];
};

// Generate initials from speaker name
export const getInitials = (name) => {
  if (!name) return '?';

  const parts = name.split(' ').filter(p => p.length > 0);
  if (parts.length === 0) return '?';

  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  // Take first letter of first two words
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
